export enum STEP_GROUP {
    FinishTutorial = "finishTutorial",
    FirstTimeUser = "firstTimeUser",
    TutorialCompanySelector = "tutorialCompanySelector",
    TutorialTaskGroups = "tutorialTaskGroups"
}

export enum TOOLTIP_ACTIONS {
    Finish = "finish",
    GetStarted = "get started",
    Next = "next",
    NextFeature = "next feature"
}
